import { Component, Injectable, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Route, Router} from '@angular/router';
import { ExpedienteService } from 'app/services/expediente.service';
import { BsModalRef} from 'ngx-bootstrap/modal';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-asignacion',
  templateUrl: './asignacion.component.html',
  styleUrls: ['./asignacion.component.scss']
})
@Injectable()
export class AsignacionComponent implements OnInit {

  @Input() idconvocatoria;
  convocatoria?: string;
  closeBtnName?: string;
  list: any[] = [];
  expedientes: any;
  loading: boolean;
  universidades: any;
  centros: any[] = [];

  constructor(public activeModal: NgbActiveModal,private expedienteService: ExpedienteService,private router: Router,private route: ActivatedRoute) { 
    this.loadUniversidades();
  }

  ngOnInit() {
   


  }



  loadUniversidades() {
    this.expedienteService.getUniversidades().subscribe(
      data => {
        this.universidades = data.UNIVERSIDADES;
        console.log(data);
      },
      error => {
        if (error.status = 401) {alert('Error'); }
      }
    );


  }




  loadCentros(idconvocatoria,event) {
    this.loading=true;
    this.expedienteService.getCentrosDisponibles(event.target.value,idconvocatoria).subscribe(
      data => {
        this.centros = data;
        console.log(data);
        this.loading=false;
      },
      error => {
        if (error.status = 401) {alert('Error'); }
      }
    );
  }


  guardar() {
    this.expedienteService.postCentros(this.idconvocatoria,this.centros).subscribe(
      data => {
        console.log(data);        
        this.activeModal.close();

        
      },
      error => {
        if (error.status = 401) {alert('Error'); }
      }
    );
    

  }
  
}



// WEBPACK FOOTER //
// /app/src/app/modules/expedientes/asignacion/asignacion.component.ts